const testBracket = (str, brackets, l) => {
  return brackets.indexOf(str[0]) + 1 || l && brackets.indexOf(str[l]) + 1;
};
export {
  testBracket as t
};

